'use client';

import { Input } from '../ui/input';
import { FormField } from '../ui/form-field';

/**
 * AddTaxForm — mirrors AddTollForm structure.
 *
 * Props:
 *   formData          : { name, percentage, isActive }
 *   onFormDataChange  : (newFormData) => void
 *   existingNames     : string[]  — list of tax names already in the master (used for uniqueness check)
 *   editingId         : string | null — ID of the record being edited (excluded from duplicate check)
 *   nameError         : string   — external error string for the name field (passed from parent)
 *   onNameErrorChange : (msg: string) => void
 */
export default function AddTaxForm({
  formData,
  onFormDataChange,
  existingNames = [],
  editingId = null,
  nameError = '',
  onNameErrorChange,
}) {
  const updateFormData = (field, value) => {
    onFormDataChange({ ...formData, [field]: value });
  };

  const handleNameChange = (e) => {
    const value = e.target.value;
    updateFormData('name', value);

    // Uniqueness check — case-insensitive, skip the record currently being edited
    const isDuplicate = existingNames.some(
      (item) => item.name.toLowerCase() === value.trim().toLowerCase() && item.id !== editingId,
    );

    if (isDuplicate) {
      onNameErrorChange(`"${value.trim()}" already exists. Please use a different name.`);
    } else {
      onNameErrorChange('');
    }
  };

  return (
    <>
      <FormField label="Tax Name" required htmlFor="taxName">
        <Input
          id="taxName"
          placeholder="e.g. CGST, SGST, IGST, VAT"
          value={formData.name}
          onChange={handleNameChange}
          className={`h-12 text-base bg-white ${
            nameError ? 'border-red-500 focus:ring-red-500' : ''
          }`}
        />
        {nameError && <p className="text-red-500 text-sm mt-1">{nameError}</p>}
      </FormField>

      <FormField label="Percentage (%)" required htmlFor="taxPercentage">
        <Input
          id="taxPercentage"
          type="number"
          min="0"
          max="100"
          step="0.01"
          placeholder="e.g. 9, 18, 5"
          value={formData.percentage}
          onChange={(e) => updateFormData('percentage', e.target.value)}
          className="h-12 text-base bg-white"
          onWheel={(e) => e.target.blur()}
        />
      </FormField>

      {/* <FormField label="Status" htmlFor="taxActive">
        <div className="flex items-center gap-3 h-12">
          <label className="flex items-center gap-2 cursor-pointer select-none">
            <input
              id="taxActive"
              type="checkbox"
              checked={formData.isActive}
              onChange={(e) => updateFormData("isActive", e.target.checked)}
              className="w-4 h-4 accent-[color:var(--brand-primary)] cursor-pointer"
            />
            <span className="text-base text-gray-700">Active</span>
          </label>
        </div>
      </FormField> */}
    </>
  );
}
